import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X, Printer } from '../../lib/icons';
import { getBranding } from '../../lib/branding';
import { qrDataUrl, lienPortail } from '../../lib/portail';

const portalNode = () => {
  let el = document.getElementById('print-portal');
  if (!el) {
    el = document.createElement('div');
    el.id = 'print-portal';
    document.body.appendChild(el);
  }
  return el;
};

// Planche d'étiquettes QR à coller sur les caisses et bidons d'un lot.
export const EtiquettesQR = ({ reception, onClose }) => {
  const b = getBranding();
  const [node] = useState(portalNode);
  const [nombre, setNombre] = useState(12);
  const [src, setSrc] = useState('');
  const lien = lienPortail('lot', reception.id);

  useEffect(() => {
    qrDataUrl(lien).then(setSrc);
  }, [lien]);

  const planche = (
    <div className="mx-auto max-w-[780px] bg-white p-6 text-slate-900">
      <div className="mb-4 flex items-center justify-between border-b-2 border-slate-900 pb-2">
        <div className="flex items-center gap-2">
          {b.logo && <img src={b.logo} alt="Logo" className="h-12 w-12 object-contain" />}
          <div>
            <p className="font-heading text-sm font-black">{b.nom}</p>
            <p className="font-data text-[10px] text-slate-600">Planche d'étiquettes — lot {reception.id}</p>
          </div>
        </div>
        <p className="font-data text-[10px] text-slate-600">{nombre} étiquettes · {reception.date}</p>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {Array.from({ length: nombre }).map((_, i) => (
          <div key={i} className="flex items-center gap-2 border border-dashed border-slate-400 p-2">
            {src && <img src={src} alt="QR" className="h-16 w-16" />}
            <div className="min-w-0">
              <p className="font-heading text-xs font-black leading-tight">{reception.id}</p>
              <p className="truncate font-data text-[9px] text-slate-600">{reception.tiers}</p>
              <p className="font-data text-[9px] text-slate-600">{reception.date}</p>
              <p className="font-data text-[8px] leading-tight text-slate-500">Scannez pour le suivi</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const overlay = (
    <div data-testid="etiquettes-overlay" className="fixed inset-0 z-[70] overflow-auto bg-slate-900/60 p-4 print:hidden">
      <div className="mx-auto w-full max-w-3xl bg-white">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 px-4 py-3">
          <p className="font-heading text-sm font-bold text-slate-900">Étiquettes QR — lot {reception.id}</p>
          <div className="flex items-center gap-2">
            <label className="font-data text-xs text-slate-600">Nombre</label>
            <input
              data-testid="etiquettes-nombre"
              type="number"
              min="1"
              max="60"
              value={nombre}
              onChange={(e) => setNombre(Math.max(1, Math.min(60, Number(e.target.value) || 1)))}
              className="h-10 w-20 border border-slate-300 bg-slate-50 px-2 text-center font-data text-sm outline-none focus:border-slate-900"
            />
            <button
              type="button"
              data-testid="etiquettes-imprimer"
              onClick={() => window.print()}
              className="flex h-10 items-center gap-2 bg-slate-900 px-4 text-sm font-bold text-white transition-colors duration-150 hover:bg-slate-700"
            >
              <Printer size={15} /> Imprimer
            </button>
            <button
              type="button"
              data-testid="etiquettes-fermer"
              onClick={onClose}
              className="border border-slate-300 p-2 text-slate-600 transition-colors duration-150 hover:bg-slate-900 hover:text-white"
            >
              <X size={16} />
            </button>
          </div>
        </div>
        <div className="max-h-[70vh] overflow-auto">{planche}</div>
      </div>
    </div>
  );

  return (
    <>
      {overlay}
      {createPortal(<div className="hidden print:block">{planche}</div>, node)}
    </>
  );
};
